/**
 * 规范化数据索引（统一大小写）
 * @param data - 原始数据数组
 * @param toLowerCase - 是否转为小写（默认true）
 * @returns 规范化后的数据
 */
export const normalizeDataIndex = (
  data: any[],
  toLowerCase = true
) => {
  return data.map(item => {
    const normalizedItem: { [key: string]: any } = {};
    Object.keys(item).forEach(key => {
      const normalizedKey = toLowerCase ? key.toLowerCase() : key.toUpperCase();
      normalizedItem[normalizedKey] = item[key];
    });
    return normalizedItem;
  });
};

/**
 * 格式化检查日期（提取年月日）
 * @param studyTime - 原始时间字符串
 * @returns 格式化后的日期对象
 */
export const formatStudyDate = (studyTime: string) => {
  if (!studyTime) return { yearMonthDay: '' };

  const date = new Date(studyTime);
  if (isNaN(date.getTime())) return { yearMonthDay: '' };

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return { yearMonthDay: `${year}-${month}-${day}` };
};

/**
 * 转换检查状态为中文文本
 * @param state - 原始状态码
 * @returns 中文状态文本
 */
export const getStateText = (state: string | undefined) => {
  if (!state) return '';

  switch (state) {
    case '0':
      return '待检查';
    case '1':
      return '待诊断';
    case '2':
      return '已诊断';
    case '3':
    case '4':
    case '5':
      return '已审核';
    default:
      return '';
  }
};

/**
 * 提取URL中的关键查询参数（用于检查数据请求）
 * @param search - location.search字符串
 * @returns 过滤后的参数对象
 */
export const extractQueryParams = (search: string) => {
  const queryParams = new URLSearchParams(search);
  const params: { [key: string]: string } = {};

  // 关键参数列表（用于数据请求）
  const paramKeys = [
    'study_id', 'patient_no', 'patient_id', 'in_no', 'out_no',
    'identification_no', 'ybkh','jzkh', 'idCard', 'register_key'
  ];

  // 提取第一个有效参数（用于验证存储Key）
  let firstParamValue = '';
  for (const key of paramKeys) {
    const value = queryParams.get(key);
    if (value) {
      firstParamValue = value;
      break;
    }
  }

  // 提取所有非过滤参数
  queryParams.forEach((value, key) => {
    if (
      !['flag', 'hidename', 'code', 'expiration', 'from'].includes(key)
    ) {
      params[key] = value;
    }
  });

  return { params, firstParamValue: firstParamValue || 'default' };
};
